// extracted by mini-css-extract-plugin
module.exports = {"file":"fileItem_file__3kezj","icon":"fileItem_icon__AIK6G"};